document.addEventListener("DOMContentLoaded", function () {
    const track = document.querySelector(".carousel-track");
    const items = document.querySelectorAll(".carousel-item");
    const prevBtn = document.querySelector(".carousel-btn.prev");
    const nextBtn = document.querySelector(".carousel-btn.next");

    if (!track || items.length === 0) return;

    let index = 0;
    let itemWidth = 0;
    let maxIndex = 0;
    let itemsVisible = 3;
    let isDragging = false;
    let startX = 0;
    let prevTranslate = 0;
    let currentTranslate = 0;

    function calcValues() {
        const w = window.innerWidth;

        if (w <= 768) {
            itemsVisible = 1;
        } else if (w <= 960) {
            itemsVisible = 2;
        } else {
            itemsVisible = 3;
        }

        const r1 = items[0].getBoundingClientRect();
        const r2 = items[1] ? items[1].getBoundingClientRect() : r1;

        itemWidth = r2.left - r1.left;

        maxIndex = Math.max(0, items.length - itemsVisible);
        index = Math.min(index, maxIndex);

        prevTranslate = -index * itemWidth;
        applyTranslate();
        updateButtons();
    }

    function applyTranslate() {
        track.style.transform = `translateX(${prevTranslate}px)`;
    }

    function updateButtons() {
        prevBtn.disabled = index <= 0;
        nextBtn.disabled = index >= maxIndex;
    }

    function goNext() {
        if (index < maxIndex) {
            index++;
            prevTranslate = -index * itemWidth;
            applyTranslate();
            updateButtons();
        }
    }

    function goPrev() {
        if (index > 0) {
            index--;
            prevTranslate = -index * itemWidth;
            applyTranslate();
            updateButtons();
        }
    }

    nextBtn.addEventListener("click", goNext);
    prevBtn.addEventListener("click", goPrev);

    function dragStart(x) {
        isDragging = true;
        startX = x;
        track.classList.add("dragging");
        track.style.transition = "none";
    }

    function dragMove(x) {
        if (!isDragging) return;
        currentTranslate = prevTranslate + (x - startX);
        track.style.transform = `translateX(${currentTranslate}px)`;
    }

    function dragEnd() {
        if (!isDragging) return;
        isDragging = false;
        track.classList.remove("dragging");
        track.style.transition = "transform 0.4s ease";

        index = Math.round(Math.abs(currentTranslate) / itemWidth);
        index = Math.max(0, Math.min(index, maxIndex));

        prevTranslate = -index * itemWidth;
        applyTranslate();
        updateButtons();
    }

    track.addEventListener("mousedown", e => dragStart(e.clientX));
    track.addEventListener("mousemove", e => dragMove(e.clientX));
    track.addEventListener("mouseup", dragEnd);
    track.addEventListener("mouseleave", dragEnd);

    track.addEventListener("touchstart", e => dragStart(e.touches[0].clientX));
    track.addEventListener("touchmove", e => dragMove(e.touches[0].clientX));
    track.addEventListener("touchend", dragEnd);

    window.addEventListener("resize", calcValues);

    calcValues();
});
